<template>
  <div class="wrap" v-if="!loading">
    <div v-if="billList.length">
      <div class="price">应付总额 ¥ {{ billAmount }}</div>
      <van-checkbox-group v-model="result" class="plan-list-group">
        <van-cell-group class="plan-list">
          <van-cell
            class="plan-item"
            v-for="(item, index) in billList"
            clickable
            :key="item.deductIndex"
            @click="toggle(index)"
          >
            <template #title>
              <div class="content">
                <div class="name">
                  第{{ item.deductIndex }}期 ¥{{ item.deductAmount }}
                  <span class="timeout" v-if="item.state === 1"
                    >超时未支付</span
                  >
                </div>
              </div>
              <div class="desc" v-if="item.state === 0">
                最后支付日 {{ computedTime(item.repaymentDate) }}
              </div>
              <div v-else class="desc warning">
                请尽快支付，避免造成违约风险
              </div>
            </template>
            <template #right-icon>
              <van-checkbox
                :name="item.deductIndex"
                ref="checkboxes"
                :disabled="index === 0"
              />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <div class="footer">
        <div class="btn" @click="handlePay">去支付</div>
      </div>
    </div>
    <div v-else class="empty-wrap">
      <img
        src="https://common-h5-dev.xiangshuheika.com/static/upload/202511184501a985913be.png"
      />
      <p>没有需要支付账单</p>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  onMounted,
  computed,
} from "@vue/composition-api";
import dayjs from "dayjs";

import { useRouter, useStore } from "@/components/use/base";

import { getJiayinBill } from "@/apis/jiayin";

import Vue from "vue";
export default defineComponent({
  setup() {
    const router = useRouter();
    const billList = ref([]);
    const store = useStore();
    const billAmount = ref(0);
    const result = ref([]);
    const loading = ref(true);
    const checkboxes = ref(null);
    const vm = Vue.prototype;
    const computedTime = computed(() => (time) => {
      return dayjs(time).format("YYYY年MM月DD日");
    });

    const initData = async () => {
      const { data } = await getJiayinBill({
        orderId: store.state.orderId,
      });
      billList.value = data.billOrderItems;
      billAmount.value = data.totalAmount;
      result.value = data.billOrderItems
        .filter((item) => item.state === 1)
        .map((item) => item.deductIndex);
      if (result.value.length === 0 && data.billOrderItems.length > 0) {
        result.value = [data.billOrderItems[0].deductIndex];
      }
    };

    const handleChange = (deductIndex) => {
      if (result.value.includes(deductIndex)) {
        result.value = result.value.filter((item) => item !== deductIndex);
      } else {
        result.value.push(deductIndex);
      }
    };
    const toggle = (index) => {
      if (index === 0) return;
      checkboxes.value[index].toggle();
    };
    const handlePay = () => {
      // 不能跨期支付
      const isJumpDeduct = result.value.some((item) => {
        const index = billList.value.findIndex((r) => r.deductIndex === item);
        if (index > 0) {
          const prevItemIndex = billList.value[index - 1].deductIndex;
          if (!result.value.includes(prevItemIndex)) {
            return true;
          }
          return false;
        }
        return false;
      });
      if (isJumpDeduct) {
        vm.$toast("请按照期次顺序支付哦~");
        return;
      }
      router.push(
        `/jiayinPay?orderId=${
          store.state.orderId
        }&indexList=${result.value.join(",")}`
      );
    };

    onMounted(async () => {
      const fetching = vm.$loading();
      try {
        await initData();
      } finally {
        loading.value = false;
        fetching.clear();
      }
    });

    return {
      result,
      billList,
      computedTime,
      handlePay,
      loading,
      handleChange,
      billAmount,
      toggle,
      checkboxes,
    };
  },
});
</script>

<style scoped lang="less">
.wrap {
  background: #f5f5f5;
  min-height: calc(100vh - 88px);
  overflow: hidden;
  padding: 0 12px;
  padding-bottom: 88px;
}

.empty-wrap {
  margin: 0 auto;
  margin-top: 61px;
  width: 164px;

  img {
    width: 164px;
    height: 151px;
  }

  p {
    margin-top: 31px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
    text-align: center;
  }
}

.price {
  margin: 16px 0;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}

.timeout {
  background: #ff5001;
  padding: 3px 5px;
  border-radius: 8px;
  color: #ffffff;
  margin-left: 12px;
  font-size: 10px;
}
.plan-list {
  background: transparent;
}

.plan-item {
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  border-radius: 10px;
  margin-top: 12px;
  /deep/ .van-checkbox__icon--disabled .van-icon {
    color: #fff !important;
    background: #1989fa !important;
    border-color: #1989fa !important;
    opacity: 0.5 !important;
  }
}

.content {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .name {
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }
}
.desc {
  margin-top: 8px;
  font-weight: 400;
  font-size: 10px;
  color: #666666;
  line-height: 14px;
  &.warning {
    color: #ff3141;
  }
}

.footer {
  position: fixed;
  width: 375px;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  box-shadow: 0px -2px 4px 0px rgba(194, 194, 194, 0.19);

  .btn {
    margin: 12px;
    height: 44px;
    font-weight: 500;
    font-size: 17px;
    color: #ffffff;
    line-height: 44px;
    text-align: center;
    background: linear-gradient(115deg, #4082e7 0%, #3254f2 100%);
    border-radius: 22px;
  }
}
</style>


